import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { useLang } from "@/context/LangContext";

const Story = () => {
  const { lang } = useLang();
  const isFr = lang === "fr";

  return (
    <section
      data-testid="story-page"
      className="max-w-4xl mx-auto px-6 sm:px-10 py-20 md:py-28"
    >
      <Seo
        lang={lang}
        path="/story"
        title={isFr ? "Notre histoire" : "Our story"}
        description={
          isFr
            ? "Pourquoi myFLOVEA — la mission, les valeurs et l'origine d'une marque pensée pour le confort qui te suit partout."
            : "Why myFLOVEA — the mission, the values and the origin of a brand built for comfort that follows you everywhere."
        }
      />
      <div className="eyebrow mb-6">{isFr ? "Pourquoi myFLOVEA" : "Why myFLOVEA"}</div>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] tracking-tight">
        {isFr
          ? "Le bien-être ne devrait jamais rester à la maison."
          : "Wellness shouldn't stay home."}
      </h1>

      <div className="mt-12 aspect-[16/9] overflow-hidden bg-[#ebe7df] rounded-sm">
        <img
          src="/photos/story-office.webp"
          alt="myFLOVEA — Le confort jusqu'au bureau"
          loading="lazy"
          decoding="async"
          width="1600"
          height="900"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="mt-14 space-y-6 text-[17px] text-[#1A1A1A] leading-relaxed">
        <p>
          {isFr
            ? "Nous croyons que les meilleurs rituels de confort sont ceux qui voyagent avec vous. Dans le métro, sur un vol, derrière un bureau, à la maison."
            : "We believe the best comfort rituals are the ones that travel with you. On the subway, on a flight, at a desk, at home."}
        </p>
        <p>
          {isFr
            ? "myFLOVEA sélectionne des produits bien-être tech soigneusement testés — livrés chez vous en 3 à 14 jours selon le produit."
            : "myFLOVEA curates carefully-tested wellness-tech products — delivered to you in 3 to 14 days depending on the product."}
        </p>
        <p>
          {isFr
            ? "Pas d'intermédiaires, pas de mise en avant inutile — juste deux innovations, choisies avec soin."
            : "No middlemen, no fluff — just two innovations, carefully chosen."}
        </p>
      </div>

      <div className="mt-16">
        <Link
          to="/"
          data-testid="story-page-cta"
          className="inline-flex items-center gap-3 bg-[#1A1A1A] text-[#F5F0EB] px-8 py-4 text-xs tracking-[0.22em] uppercase hover:bg-[#2a2a2a] transition-colors rounded-sm"
        >
          {isFr ? "Voir la collection" : "See the collection"}
        </Link>
      </div>
    </section>
  );
};

export default Story;
